export const noVendorSelected = {
	name: "phronesis.error.novendor.title",
	message: "phronesis.error.novendor.message",
}

export const noCategorySelected = {
	name: "phronesis.error.noCategory.title",
	message: "phronesis.error.noCategory.message",
}

export const noDepartmentSelected = {
	name: "phronesis.error.noDepartment.title",
	message: "phronesis.error.noDepartment.message",
}
